const getUrlTypeMap = {
    all: 'All',
    company: 'Companies',
    job: 'Jobs',
    user: 'Members',
    editorial_content: 'Articles',
    community: 'Community',
    group: 'Groups',
};

export const getUrl = (type, term) => {
    const selectedType = type || 'all';
    const encodededTerm = encodeURIComponent(term);

    const urlMapKey = (Object.keys(getUrlTypeMap) || []).find(
        (i) => i === selectedType
    );

    if (urlMapKey === 'job') return `/jobs/find?keywords=${encodededTerm}`;
    if (urlMapKey === 'group') return `/groups/search?keyword=${encodededTerm}`;
    if (urlMapKey === 'all') return `/search?term=${encodededTerm}`;

    return `/search?term=${encodededTerm}&type=${type}`;
};
